import styled from 'styled-components'

import { Colors } from '@fourthwall/components'

export const Title = styled.div`
  line-height: 24px;
`

export const SecondaryTitle = styled.span`
  color: var(--text-secondary);
`

export const Summary = styled.div`
  color: ${Colors.GS600};
  font-size: 14px;
  line-height: 21px;
`
